<template>
    <div id="game" class="game futura row">
        <div class="col-12" v-if="gm.inGamePlayerCheck(logged_in_user)">
            <a href="/matchrequests" class="btn btn-danger btn-lg btn-block">{{__('games.end_watch')}}</a>
        </div>
        <div class="headerContainer">
            <template v-if="gm.players">
                <template v-if="gm.players.length <= 2">
                <game-asset-score-player
                    :player_name="player.name"
                    :player_id="player.id"
                    :active_player="gm.isActivePlayer(player.id)"
                    :score_player="player.score"
                    :sets_player="player.sets"
                    :legs_player="player.legs"
                    :throw_player="player.throw"
                    :singlescore_player="JSON.stringify(player.singlescores)"
                    :calculated_score="calculatedScore(player.id)"
                    :gm="gm"
                    :dartcounter="dartcounter"
                    :cputimer="player.cpu_time"
                    v-for="player, idx in gm.players"
                    :key="idx"
                    :deactivate_smallscore = "true"
                />
                </template>
                <template v-else>
                    <game-asset-scores-small :players="gm.players" :current="gm.currentPlayer"></game-asset-scores-small>
                    <game-asset-score-player
                        :player_name="gm.currentPlayer.name"
                        :player_id="gm.currentPlayer.id"
                        :active_player="gm.isActivePlayer(gm.currentPlayer.id)"
                        :score_player="gm.currentPlayer.score"
                        :sets_player="gm.currentPlayer.sets"
                        :legs_player="gm.currentPlayer.legs"
                        :throw_player="gm.currentPlayer.throw"
                        :singlescore_player="JSON.stringify(gm.currentPlayer.singlescores)"
                        :calculated_score="calculatedScore(gm.currentPlayer.id)"
                        :cputimer="gm.currentPlayer.cpu_time"
                        :gm="gm"
                        :dartcounter="dartcounter"
                        :deactivate_smallscore = "true"
                    />
                </template>
                <div class="col-xl-2 splitscoreContainer shadow-inactive">
                    <div class="splitscoreLabel">{{__('games.to_hit')}}</div>
                    <div class="splitscoreNumber">{{showHitNumber()}}</div>
                </div>
            </template>
        </div>

        <div class="subnav" v-if="layoutProfile && (layoutProfile.show_history || layoutProfile.show_numpad)">
            <a href="#" v-if="layoutProfile &&layoutProfile.show_numpad" :class="['item', showmenu == 'numpad' ? 'active' : 'inactive']" @click="showSubMenu('numpad')"><i class="fas fa-th"></i> {{__('games.input')}} <a href="#" class="numpad-helper" @click="$refs.numpad.toggleHelper()"><i class="far fa-question-circle"></i></a></a>
            <a href="#" v-if="layoutProfile &&layoutProfile.show_history" :class="['item', showmenu == 'history' ? 'active' : 'inactive']" @click="showSubMenu('history')"><i class="fas fa-list-ol"></i> {{__('games.history')}}</a>
        </div>

        <div class="flexrow" v-if="layoutProfile">
            <div class="numpad shadow-inactive" v-if="showmenu =='numpad' && layoutProfile.show_numpad">
                <numpad :disabledInput='disabledInput' @hit="hitTarget" @nohit="noHitTarget" @clr="clr" @send="send" :only="['hit-nohit']" ref="numpad"></numpad>
            </div>
            <numpad hidden="true" :disabledInput='disabledInput' @hit="hitTarget" @nohit="noHitTarget" @clr="clr" @send="send" :only="['hit-nohit']" ref="numpad" v-if="!layoutProfile.show_numpad || showmenu != 'numpad'"></numpad>
            <div class="history shadow-inactive" v-if="showmenu =='history' && layoutProfile.show_history">
                <game-asset-game-history
                    :content="verlauf()"
                    :headers ="historyHeaders"
                    :hiderounds="true"
                    :players="gm.players"
                />
            </div>
        </div>

        <b-modal id="modal-leg-end" title="Leg beendet" @hidden="nextLeg">
            <div class="results">
                <game-asset-score-player
                    :player_name="gm.players[0].name"
                    :player_id="gm.players[0].id"
                    :active_player="gm.isActivePlayer(gm.players[0].id)"
                    :score_player="gm.players[0].score"
                    :sets_player="gm.players[0].sets"
                    :legs_player="gm.players[0].legs"
                    :throw_player="gm.players[0].throw"
                    :singlescore_player="JSON.stringify(gm.players[0].singlescores)"
                    :calculated_score="calculatedScore(gm.players[0].id)"
                    :gm="gm"
                    :dartcounter="dartcounter"
                    :winner="this.winner.name"
                    v-if="this.winner != null"
                />
                <game-asset-score-player
                    :player_name="gm.players[1].name"
                    :player_id="gm.players[1].id"
                    :active_player="gm.isActivePlayer(gm.players[1].id)"
                    :score_player="gm.players[1].score"
                    :sets_player="gm.players[1].sets"
                    :legs_player="gm.players[1].legs"
                    :throw_player="gm.players[1].throw"
                    :singlescore_player="JSON.stringify(gm.players[1].singlescores)"
                    :calculated_score="calculatedScore(gm.players[1].id)"
                    :gm="gm"
                    :winner="this.winner.name"
                    v-if="this.winner != null && gm.players[1]"
                />
            </div>
            <div class="history shadow-light mt-3">
                    <game-asset-game-history
                        :content="verlauf()"
                        :headers ="historyHeaders"
                        :players="gm.players"
                    />
                </div>
            <template #modal-footer>
                <game-asset-next-leg @nextleg="nextLeg"></game-asset-next-leg>
            </template>
        </b-modal>

        <game-asset-video-player :throwPoints="gm.lastscore"></game-asset-video-player>
        <game-asset-determine-start-player :startDetermineStartPlayer="startingPlayerDetermined" :firstleg="gm.firstleg" :game="game" @activePlayer="setStartingPlayer" :gameState="gm.gameState" :players="gm.players"></game-asset-determine-start-player>
        <game-asset-game-results-around-the-clock :game="game" :gm="gm" :showResults="showResults"></game-asset-game-results-around-the-clock>
    </div>
</template>

<script>
    import numpad from './gameAssets/gameAssetNumpad.vue';
    import GameAssetScorePlayer from './gameAssets/gameAssetScorePlayer.vue';
    import GameAssetGameHistory from './gameAssets/gameAssetGameHistory.vue';
    import ConnectionManager from './gameAssets/gameConnectionManager';
    import GameAssetDetermineStartPlayer from './gameAssets/gameAssetDetermineStartPlayer.vue';
    import DartsParser from './gameAssets/gameDartsParser';
    import AudioPlayer from './gameAssets/gameAssetAudioPlayer.js';
    import GameAssetVideoPlayer from './gameAssets/gameAssetVideoPlayer.vue';

    import GameManger from './gameAssets/gameManager';
    import GameAssetGameResultsAroundTheClock from './gameAssets/gameAssetGameResultsClock';

    export default {
        props: ['game_prop', 'players_prop', 'logged_in_user', 'logged_in_player'],
        mixins: [AudioPlayer],
        components: {
            numpad,
            GameAssetScorePlayer,
            GameAssetGameHistory,
            GameAssetDetermineStartPlayer,
            GameAssetVideoPlayer,
            GameAssetGameResultsAroundTheClock
        },
        data() {
            return {
                throw: 0,
                game: this.game_prop,
                content: {},
                winner: null,
                disabledInput: true,
                watchstarted: false,
                targets1: ['1', '18', '4', '13', '6', '10', '15', '2', '17', '3', '19', '7', '16', '8', '11', '14', '9', '12', '5', '20', 'BE'],
                targets2: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', 'BE'],
                targetMultiplier: ['D'],
                targets: [],
                startingPlayerDetermined: false,
                gameState: [],
                players: [],
                historyHeaders: [
                    {name: __("games.hit"), value: "singlescores"},
                    {name: __("games.points_round"), value: "roundscore"},
                    {name: __("games.points"), main: true, value: "score"},
                ],
                showmenu: 'numpad',
                showResults: false,
                layoutProfile: null,
                dartcounter: 0,
            }
        },
        created() {

            //create game manager object and read options
            this.gm = new GameManger(this);
            this.gm.start();
        },
        mounted() {
            if (this.game.status == "completed") {
                //do not parse the game when it is completed
                //the game show results component will do this
                return;
            }
            this.layoutProfile = window.currentProfile ? window.currentProfile : {layout: 1, show_history: true, show_numpad: true};
            if (!this.layoutProfile.show_numpad && this.layoutProfile.show_history) this.showmenu = 'history';
            if (this.layoutProfile.webcamDisplayOption == "webcamDisplayActivePlayer") this.webcamToggle = true;

            this.$root.$emit('ProfileSelectorAddObserver', this.loadProfile)
            if (this.gm.debugger) console.log("players: ", this.gm.players)

            //create targets based on options
            if (this.gm.gameoptions['Ziel'] == "Single") this.targetMultiplier = "";
            if (this.gm.gameoptions['Ziel'] == "Double") this.targetMultiplier = "D";
            if (this.gm.gameoptions['Ziel'] == "Triple") this.targetMultiplier = "T";
            if (this.gm.gameoptions['Anordnung'] == "der Reihe nach 1-20") {
                this.targets2.forEach(t => {
                    if (t == "BE" && this.targetMultiplier == "T") this.targetMultiplier = "D";
                    this.targets.push(this.targetMultiplier+t);
                });
            } else {
                this.targets1.forEach(t => {
                    if (t == "BE" && this.targetMultiplier == "T") this.targetMultiplier = "D";
                    this.targets.push(this.targetMultiplier+t);
                });
            }

        },
        methods: {
            loadProfile(profile) {
                this.layoutProfile = profile;
                if (this.layoutProfile.webcamDisplayOption == "webcamDisplayActivePlayer") this.webcamToggle = true;
            },
            createUIElements() {
                return new Promise((resolve, reject) => {
                    resolve();
                })
            },
            setPlayerOptions() {
                return new Promise((resolve, reject) => {
                    this.gm.players.forEach(player => {
                        player.target = this.targets[0];
                        player.targetIndex = 0;
                    });
                    this.clr();
                    resolve();
                });
            },
            setStartingPlayer(id) {
                console.log("setting startting player to: " + id)
                this.gm.setActivePlayer(id, true);
                this.gm.setNextState();
            },
            prepareActivePlayer() {
                return new Promise((resolve, reject) => {
                    this.gm.getActivePlayer().targetIndex = this.gm.getActivePlayer().score;
                    this.gm.getActivePlayer().throw = 0;
                    this.gm.getActivePlayer().singlescores = [];
                    this.clr();
                    resolve();
                })
            },
            winCheck() {
                return new Promise((resolve, reject) => {
                    var winner = false;
                    this.gm.players.forEach(player => {
                        if (player.targetIndex == this.targets.length) {
                            winner = true;
                        }
                    });
                    resolve({winner: winner});
                })
            },
            winCheckSingle() {
                return new Promise((resolve, reject) => {
                    var winner = false;
                    if (player.targetIndex == this.targets.length) {
                        winner = true;
                    }
                    resolve({winner: winner});
                })
            },
            addSingle(number) {
                if (this.logged_in_user == this.gm.getActivePlayer().user_id) {
                    if (this.dartcounter >= 3) return; //do not parse inputs if three darts where thrown
                    this.parseSingleScore(this.gm.getActivePlayer(), DartsParser.parse(number));
                }
            },
            clr() {
                var targetReturn = 0;
                this.gm.getActivePlayer().singlescores.forEach(element => {
                    if (element.missed !== true) {
                        targetReturn += 1;
                    }
                });
                this.gm.getActivePlayer().targetIndex -= targetReturn;
                this.gm.getActivePlayer().throw = 0;
                this.gm.getActivePlayer().singlescores = [];
                this.gm.resetRound();
                this.throw = 0;
                this.dartcounter = 0;
                this.$forceUpdate();
            },
            send() {
                if (this.logged_in_user == this.gm.getActivePlayer().user_id && !this.disabledInput) {
                    this.disabledInput = true;
                    axios.post("/api/games/" + this.game.id + "/sendfullscore", {
                        player: this.gm.getActivePlayer().id,
                        score: this.throw,
                        singlescores: this.gm.getActivePlayer().singlescores
                    }).then(() => {
                        setTimeout(() => {
                            this.gm.setNextState();
                        }, 250);
                    });
                }
            },

            hitTarget() {
                var target = this.targets[this.gm.getActivePlayer().targetIndex];
                this.addSingle(target);
            },
            noHitTarget() {
                this.addSingle(0);
            },
            finishRoundOrSend() {
                if (this.logged_in_user == this.gm.getActivePlayer().user_id && !this.disabledInput) {
                    if (this.gm.getActivePlayer().singlescores.length > 0 && this.gm.getActivePlayer().singlescores.length < 3) {
                         //add zeros to the remaining darts
                        if (this.dartcounter < 3) {
                            axios.post("/games/singlescore", {dart: 0, times: 3 - this.dartcounter});
                        }
                        this.gm.finishRound();
                    } else {
                        this.send();
                    }
                }
            },
            parseContent() {
                //parses the content of the leg to show what happens in this game
                if (!this.content) return;
                var last_active_player_id = 0;
                var last_score = 0;
                this.gm.players.forEach(player => {
                    player.score = 0;
                });
                this.content.throws.forEach(t => {
                    this.gm.players.forEach(player => {
                        if (t.player == player.id) {
                        player.score += parseInt(t.fullscore);
                        player.throw = t.fullscore;
                        last_active_player_id = player.id;
                        last_score = player.throw;
                        }
                    })
                });
                return {lastplayer:last_active_player_id, lastscore:last_score};
            },
            verlauf() {
                //parse the content throws to generate a nice viewable score list
                if (!this.content || !this.content.throws) return [];
                let players = [];
                this.gm.players.forEach(player => {
                    players.push({id: player.id, start: 0, rows: []});
                });
                players.forEach(player => {
                    player.rows.push({
                        score: player.start,
                        round: "-"
                    })
                    if (this.content && this.content.throws)
                        for (let i = 0; i < this.content.throws.length; i++) {
                            const t = this.content.throws[i];
                            if (t.player == player.id) {
                                let singlescores = '';
                                if (t.singlescores)
                                    t.singlescores.forEach(sc => {
                                        singlescores += sc.str + " ";
                                    });
                                player.start = t.fullscore == 0 ? Math.ceil(player.start /2) : parseInt(player.start) + parseInt(t.fullscore);
                                player.rows.push({
                                    score: player.start,
                                    roundscore: t.fullscore,
                                    singlescores: singlescores,
                                })
                            }
                        }
                })
                if (window.player && window.player.roundsort == 2) {
                    players.forEach(player => {
                        player.rows = player.rows.reverse();
                    });
                }
                return {players: players, custom: true};
            },
            showWinner() {
                var winner = undefined;
                this.gm.players.forEach(player => {
                    if (player.id == this.game.winner_id) {
                        winner = player;
                    }
                });
                this.winner = winner;
                if (this.winner != null)
                    this.showResults = true;
            },
            backToMatchmaking() {
                window.location.href = "/matchrequests/";
            },
            parseSingleScore(activeplayer, dart) {
                // if (this.active_player != player_id) return; //do not parse inputs if the sender is not the active player
                var target = this.targets[activeplayer.targetIndex];
                if (target != dart.str) dart.missed = true;
                //mark as missed if dart value is 0
                if (dart.value == 0) dart.missed = true;
                if (target == dart.str) activeplayer.targetIndex += 1;

                if (activeplayer.singlescores.length < 3) {
                    this.throw = 0;
                    this.dartcounter = 0;
                    activeplayer.singlescores.push(dart);
                    activeplayer.singlescores.forEach(score => {
                        this.dartcounter +=1;
                        if (score.missed !== true)
                            this.throw += 1;
                    });
                    if (this.dartcounter == 3) {
                        this.gm.finishRound();
                    }

                    if (dart.missed) this.playAudioFile("miss");
                    if (dart.base == 25 && dart.multiplier == 2) this.playAudioFile("dbull");
                    if (dart.base == 20 && dart.multiplier == 3) this.playAudioTripple(20);
                    if (dart.base == 19 && dart.multiplier == 3) this.playAudioTripple(19);
                    if (dart.base == 18 && dart.multiplier == 3) this.playAudioTripple(18);
                    if (dart.base == 17 && dart.multiplier == 3) this.playAudioTripple(17);
                }
            },
            showHitNumber() {
                return this.targets[this.gm.getActivePlayer().targetIndex];
            },
            showNextLeg() {
                this.$bvModal.show('modal-leg-end');
            },
            nextLeg() {
                toastSuccess("Starte n&auml;chstes Leg");
                this.gm.startNextLeg()
                this.$bvModal.hide('modal-leg-end');
            },
            isFirstLeg() {
                if (!this.gameState) return false;
                return this.sets_player1 == 0 && this.legs_player1 == 0 && this.sets_player2 == 0 && this.legs_player2 == 0;
            },
            calculatedScore(player_id) {
                if (this.gm.getActivePlayer().id == player_id) {
                    return this.gm.getActivePlayer().score + parseInt(this.throw);
                }
            },
            showSubMenu(name) {
                this.showmenu = name;
            }
        }
    }
</script>

<style scoped>

</style>
